<template>
  <div
    class="px-3 pt-1"
    style="overflow-y: scroll;height: calc(100vh - 116px)"
  >
    <v-card
      color="#385F73"
      class="mt-0"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-avatar
            class="ma-3"
            size="50"
          >
            <v-img src="@/assets/dashboard/sell.png" />
          </v-avatar>
        </div>
        <div>
          <v-card-title
            style="color: white;"
            class="mt-2 mb-4"
          >
            {{ $t('todaySell') }} : {{ $numberFormat(todaySell) }} {{ $store.state.currency.name }}
          </v-card-title>
          <v-card-subtitle style="font-size:14px;color: rgba(255,255,255,0.49)">
            {{ $t('totalSellUntilToday') }} : {{ $numberFormat(totalSell) }}  {{ $store.state.currency.name }}
          </v-card-subtitle>
        </div>
      </div>
    </v-card>
    <v-card
      color="amber"
      class="mt-0"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title
            style="color: #5e5454;"
            class="mt-2 mb-4"
          >
            {{ $t('totalReceiveToday') }} : {{$numberFormat(todayPayedAmount)}} {{ $store.state.currency.name }}
          </v-card-title>
        </div>
      </div>
    </v-card>
    <v-card
      class="mx-auto text-center mt-0"
      color="green"
      max-width="600"
    >
      <v-card-text>
        <v-sheet color="rgba(0, 0, 0, .12)">
          <v-sparkline
            :value="value"
            color="rgba(255, 255, 255, .7)"
            height="100"
            padding="24"
            stroke-linecap="round"
            smooth
          >
            <template v-slot:label="item">
              {{ $numberFormat(item.value) }}
            </template>
          </v-sparkline>
        </v-sheet>
      </v-card-text>

      <v-card-text>
        <div
          style="color: white"
          class="font-weight-thin"
        >
          {{ $t('lastWeekSell') }} ({{ $store.state.currency.name }})
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-center">
        <v-btn
          block
          text
          @click="goTo('mSellList')"
        >
          <p
            class="mb-0"
            style="font-size: 16px;color: white"
          >
            {{ $t('report') }}
          </p>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      color="#1F7087"
      class="mt-0"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-avatar
            class="ma-3"
            size="50"
          >
            <v-img src="@/assets/dashboard/revenue.png" />
          </v-avatar>
        </div>
        <div>
          <v-card-title
            style="color: white;"
            class="mt-2 mb-4"
          >
            {{ $t('todayReturnSell') }} : {{ $numberFormat(todayReturnSell) }} {{ $store.state.currency.name }}
          </v-card-title>
          <v-card-subtitle style="font-size:14px;color: rgba(255,255,255,0.49)">
            {{ $t('totalRtuenSellUntilToday') }} : {{ $numberFormat(totalReturnSell) }}  {{ $store.state.currency.name }}
          </v-card-subtitle>
        </div>
      </div>
    </v-card>
    <v-card
      class="mx-auto text-center mt-0"
      color="deep-orange"
      max-width="600"
    >
      <v-card-text>
        <v-sheet color="rgba(0, 0, 0, .12)">
          <v-sparkline
            :value="returnValue"
            color="rgba(255, 255, 255, .7)"
            height="100"
            padding="24"
            stroke-linecap="round"
            smooth
          >
            <template v-slot:label="item">
              {{ item.returnValue }}
            </template>
          </v-sparkline>
        </v-sheet>
      </v-card-text>

      <v-card-text>
        <div
          style="color: white"
          class="font-weight-thin"
        >
          {{ $t('lastWeekReturnSell') }} ({{ $store.state.currency.name }})
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-center">
        <v-btn
          block
          text
          @click="goTo('mSellList')"
        >
          <p
            class="mb-0"
            style="font-size: 16px;color: white"
          >
            {{ $t('report') }}
          </p>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'MWeeklySell',
    data: () => ({
      todaySell: 0,
      todayReturnSell: 0,
      totalSell: 0,
      totalReturnSell: 0,
      todayPayedAmount: 0,
      value: [],
      returnValue: [],
    }),
    mounted () {
    },
    methods: {
      mountedFunction () {
        this.getTodaySell()
        this.getTodayReturnSell()
        this.getTotalSell()
        this.getTotalReturnSell()
        this.getWeeklySell()
        this.getWeeklyReturnSell()
        this.todayPayment()
      },
      todayPayment () {
        var app = this
        var connection = app.DB
        var m = this.$moment()
        var today = m.format('jYYYY/jMM/jDD')
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          where: {
            type: 'sell',
            date: {
              '-': {
                low: today,
                high: '1500/12/29',
              },
            },
          },
          aggregate: {
            sum: 'payedAmount',
          },
        }).then(function (data) {
          if (data.length > 0) {
            var sumAmountIndex = Object.keys(data[0]).findIndex((x) => x === 'sum(payedAmount)')
            app.todayPayedAmount = Object.values(data[0])[sumAmountIndex]
          }
        })
      },
      getTodaySell () {
        var app = this
        var connection = app.DB
        var m = this.$moment()
        var today = m.format('jYYYY/jMM/jDD')
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          where: {
            type: 'sell',
            date: {
              '-': {
                low: today,
                high: '1500/12/29',
              },
            },
          },
          aggregate: {
            sum: 'sumAmount',
          },
        }).then(function (data) {
          if (data.length > 0) {
            var sumAmountIndex = Object.keys(data[0]).findIndex((x) => x === 'sum(sumAmount)')
            app.todaySell = Object.values(data[0])[sumAmountIndex]
          }
        })
      },
      getTodayReturnSell () {
        var app = this
        var connection = app.DB
        var m = this.$moment()
        var today = m.format('jYYYY/jMM/jDD')
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          where: {
            type: 'returnSell',
            date: {
              '-': {
                low: today,
                high: '1500/12/29',
              },
            },
          },
          aggregate: {
            sum: 'sumAmount',
          },
        }).then(function (data) {
          if (data.length > 0) {
            var sumAmountIndex = Object.keys(data[0]).findIndex((x) => x === 'sum(sumAmount)')
            app.todayreturnSell = Object.values(data[0])[sumAmountIndex]
          }
        })
      },
      getTotalSell () {
        var app = this
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          where: {
            type: 'sell',
          },
          aggregate: {
            sum: 'sumAmount',
          },
        }).then(function (data) {
          if (data.length > 0) {
            var sumAmountIndex = Object.keys(data[0]).findIndex((x) => x === 'sum(sumAmount)')
            app.totalSell = Object.values(data[0])[sumAmountIndex]
          }
        })
      },
      getTotalReturnSell () {
        var app = this
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          where: {
            type: 'returnSell',
          },
          aggregate: {
            sum: 'sumAmount',
          },
        }).then(function (data) {
          if (data.length > 0) {
            var sumAmountIndex = Object.keys(data[0]).findIndex((x) => x === 'sum(sumAmount)')
            app.totalReturnSell = Object.values(data[0])[sumAmountIndex]
          }
        })
      },
      getWeeklySell () {
        var app = this
        var connection = app.DB
        var f = this.$moment()
        var startDate = f.subtract(7, 'days')
        var e = this.$moment()
        startDate = f.format('jYYYY/jMM/jDD')
        var today = e.format('jYYYY/jMM/jDD')
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          groupBy: 'date',
          where: {
            type: 'sell',
            date: {
              '-': {
                low: startDate,
                high: today,
              },
            },
          },
          aggregate: {
            sum: 'sumAmount',
          },
        }).then(function (data) {
          if (data.length > 0) {
            var array = []
            var amount = []
            const current = app.$moment()
            let n = 7
            while (n > 0) {
              array.push(current.format('jYYYY/jMM/jDD'))
              amount.push(0)
              current.subtract(1, 'day')
              n--
            }
            array = array.sort()
            array.map(function (value, index) {
              const i = data.findIndex(h => h.date === value)
              if (i > -1) {
                var sumAmountIndex = Object.keys(data[0]).findIndex((x) => x === 'sum(sumAmount)')
                amount[index] = Object.values(data[i])[sumAmountIndex]
              }
            })
            app.value = amount
          }
        })
      },
      getWeeklyReturnSell () {
        var app = this
        var connection = app.DB
        var f = this.$moment()
        var startDate = f.subtract(7, 'days')
        var e = this.$moment()
        startDate = f.format('jYYYY/jMM/jDD')
        var today = e.format('jYYYY/jMM/jDD')
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          groupBy: 'date',
          where: {
            type: 'returnSell',
            date: {
              '-': {
                low: startDate,
                high: today,
              },
            },
          },
          aggregate: {
            sum: 'sumAmount',
          },
        }).then(function (data) {
          if (data.length > 0) {
            var array = []
            var amount = []
            const current = app.$moment()
            let n = 7
            while (n > 0) {
              array.push(current.format('jYYYY/jMM/jDD'))
              amount.push(0)
              current.subtract(1, 'day')
              n--
            }
            array = array.sort()
            array.map(function (value, index) {
              const i = data.findIndex(h => h.date === value)
              if (i > -1) {
                var sumAmountIndex = Object.keys(data[0]).findIndex((x) => x === 'sum(sumAmount)')
                amount[index] = Object.values(data[i])[sumAmountIndex]
              }
            })
            app.returnValue = amount
          }
        })
      },
    },
  }
</script>

<style scoped>

</style>
